export const propertiesToInclude = ['id', 'selectable','mLock','evented']
